// @flow
import React, { Fragment } from 'react';
import { MdCloudUpload } from 'react-icons/lib/md';

import Popup from '../Popup';
import OpenButton from '../OpenButton';
import CreateUsersPopup from '../CreateUsersPopup';

const CreateUserInBulkPopup = () => (
  <Fragment>
    <OpenButton
      id="uploadUsers"
      size="medium"
      title="Crear usuarios en masa"
      Icon={MdCloudUpload}
      iconPosition="left"
      tint="gray"
      clearMargins
    />
    <Popup
      id="uploadUsers"
      theme="main"
      transitionType="slideDown"
      transitionMs={600}
    >
      <CreateUsersPopup />
    </Popup>
  </Fragment>
);

export default CreateUserInBulkPopup;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserInBulkPopup/index.jsx